<template>
  <div class='EnbSidebar'
  :style="{ 
    backgroundColor: Prefes.navepainel.corBackground,
    fontFamily: Prefes.navepainel.font,
    color: Prefes.navepainel.corFont,
    fontStyle: parseInt(Prefes.navepainel.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.navepainel.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.navepainel.textDecoration) ? 'underline' : '',
    fontSize: Prefes.navepainel.fontHeight + 'px'
  }"
  >
    <div class="logo">
      <img :src="Logo">
    </div>
    <link-sidebar
    v-for="(links, k) in LinkSidebar"
    :key="k"
    :data="links"
    />
    <link-sidebar
    v-for="(links, k) in [{ text: 'Sair', path: '/loja', icon: 'UserIcon01' }]"
    :key="k"
    :data="links"
    @click="GetLogout()"
    />
  </div>
</template>

<script>
import LinkSidebar from '@/components/EnbPainel/LinkSidebar'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'EnbSidebar',
  components: { LinkSidebar },
  computed: {
    ...mapGetters(['LinkSidebar', 'Logo', 'Prefes'])
  },
  methods: {
    ...mapActions(['GetLogout'])
  }
}
</script>

<style scoped>
.EnbSidebar {
  width: 20%;
  background-color: #FFFFFF;
  overflow: auto;
}

.logo {
  display: flex;
  justify-content: center;
  padding-top: 5%;
  padding-bottom: 4%;
}

img {
  width: 60%;
}

@media (max-width: 500px) {
  .EnbSidebar {
    display: none;
  }
}
</style>
